<template>
  <div>
    <!-- Input numerico -->
    <v-text-field
      @blur="visible = false"
      :disabled="disabled"
      id="input_testo"
      @input="dispatch"
      :label="label"
      type="number"
      v-model="amount"
      v-show="visible === true"
    >
    </v-text-field>

    <!-- Input testuale -->
    <v-text-field
      :disabled="disabled"
      @focus="onFocus"
      :label="label"
      type="text"
      readonly
      :value="thousandSeparator(amount)"
      v-show="visible === false"
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "input-separatore-3",
  components: {},
  props: {
    decimali_fissi: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: "" },
    value: { type: Number, default: 0 },
    numero_decimali: { type: Number, default: 2 },
  },
  data() {
    return { amount: 0, visible: false };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.amount = this.value;
      },
    },
  },
  methods: {
    dispatch() {
      let res = parseFloat(this.amount);

      /* Compongo il messaggio per aggiornare il
       * v-modedllamento della componente chiamante. */
      if (res != null && !isNaN(res)) {
        // Tronco al decimale di riferimento (me lo da la prop).
        res = res.toFixed(2);
        res = parseFloat(res);
        this.$emit("input", res);
      } else {
        // Se mi hanno dato un input farlocco emetto null.
        this.$emit("input", null);
      }
    },
    onFocus() {
      this.visible = true;
      this.$nextTick(() => {
        document.getElementById("input_testo").focus();
      });
    },
    thousandSeparator(arg) {
      let res = parseFloat(arg);

      if (this.decimali_fissi === false) {
        if (
          res !== "" &&
          res !== undefined &&
          res !== 0 &&
          res !== "0" &&
          res !== null &&
          !isNaN(res)
        ) {
          res = res.toFixed();
          res = res.replace(".", ",");
          return res.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
          return "0";
        }
      } else {
        if (
          res !== "" &&
          res !== undefined &&
          res !== 0 &&
          res !== "0" &&
          res !== null &&
          !isNaN(res)
        ) {
          // Rimpiazzo il separatore decimale con la virgola.
          res = res.toFixed(this.numero_decimali);
          res = res.toString().replace(".", ",");

          // Divido il numero nella parte intera e decimale.
          let res_init = res.split(",")[0];
          let res_final = res.split(",")[1];

          // Aggiungo un punto ogni 3 posti per le migliaia.
          res_init = res_init.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

          // Monto la stringa finale con la virgola come searatore decimale.
          res = res_init + "," + res_final;
          return res;
        } else {
          let res = "0,";
          for (let i = 0; i < this.numero_decimali; i++) {
            res += "0";
          }
          return res;
        }
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
</style>